// Admin Imports
import Dashboard from 'views/admin/Dashboard';

// Auth Imports
import SignIn from 'views/auth/SignIn';

// Icon Imports
import { GrTransaction } from 'react-icons/gr';
import {
  MdDashboard,
  MdGroup,
  MdLock,
  MdOutlineSupportAgent,
  MdGeneratingTokens,
} from 'react-icons/md';
import { VscUnverified } from 'react-icons/vsc';
import { Transactions } from 'views/admin/Transactions';
import { Users } from 'views/admin/Users';
import { SupportTicket } from 'views/admin/SupportTicket';
import { BiSupport } from 'react-icons/bi';
import { SupportChats } from 'views/admin/Support';
import { TokenInfo } from 'views/admin/TokenInfo';
import { MdAdminPanelSettings } from 'react-icons/md';
import { Admins } from 'views/admin/Admins';
import { PendingVerifications } from 'views/admin/KycPendingVerifications';
import { PermissionManagement } from 'views/admin/PermissionManagement';
import { MdSecurity } from 'react-icons/md';
import { MdAccountBalanceWallet, MdListAlt, MdSync } from 'react-icons/md';
import { MdAttachMoney } from 'react-icons/md';
import { MdCampaign } from 'react-icons/md';
import { Solvency } from 'views/admin/Solvency';
import { OrderQueue } from 'views/admin/OrderQueue';
import { RebalanceCenter } from 'views/admin/RebalanceCenter';
import { Fees } from 'views/admin/Fees';
import { PublicNotifications } from 'views/admin/PublicNotifications';
import { PERMISSION_RESOURCES } from 'constants/permissions';

const routes: RoutesType[] = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: 'dashboard',
    icon: <MdDashboard className="h-6 w-6" />,
    component: <Dashboard />,
    requiredPermission: PERMISSION_RESOURCES.DASHBOARD,
  },
  {
    name: 'Clients list',
    layout: '/admin',
    path: 'clients',
    icon: <MdGroup className="h-6 w-6" />,
    component: <Users />,
    requiredPermission: PERMISSION_RESOURCES.CLIENTS_LIST,
  },
  {
    name: 'Transactions',
    layout: '/admin',
    path: 'transactions',
    icon: <GrTransaction className="h-6 w-6" />,
    component: <Transactions />,
    requiredPermission: PERMISSION_RESOURCES.TRANSACTIONS_PAGE,
  },
  {
    name: 'Support Chats',
    layout: '/admin',
    path: 'support-chats',
    icon: <MdOutlineSupportAgent className="h-6 w-6" />,
    component: <SupportChats />,
    requiredPermission: PERMISSION_RESOURCES.SUPPORT_CHATS,
  },
  {
    name: 'Support Chats',
    layout: '/admin',
    path: 'support-chats/:chatId',
    icon: <MdOutlineSupportAgent className="h-6 w-6" />,
    component: <SupportChats />,
    secondary: true,
  },

  // COMMENTED BEFORE BACKEND WILL BE READY

  {
    name: 'Support tickets',
    layout: '/admin',
    path: 'support-tickets',
    icon: <BiSupport className="h-6 w-6" />,
    component: <SupportTicket />,
    requiredPermission: PERMISSION_RESOURCES.SUPPORT_TICKETS,
  },
  {
    name: 'Tokens info',
    layout: '/admin',
    path: 'token-info',
    icon: <MdGeneratingTokens className="h-6 w-6" />,
    component: <TokenInfo />,
    requiredPermission: PERMISSION_RESOURCES.TOKENS_INFO,
  },
  {
    name: 'User Management',
    layout: '/admin',
    path: 'manage',
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    component: <Admins />,
    requiredPermission: PERMISSION_RESOURCES.ADMINS,
  },
  {
    name: 'Permissions',
    layout: '/admin',
    path: 'permissions',
    icon: <MdSecurity className="h-6 w-6" />,
    component: <PermissionManagement />,
    requiredPermission: PERMISSION_RESOURCES.PERMISSION_MANAGEMENT,
  },
  {
    name: 'Solvency',
    layout: '/admin',
    path: 'solvency',
    icon: <MdAccountBalanceWallet className="h-6 w-6" />,
    component: <Solvency />,
    requiredPermission: PERMISSION_RESOURCES.SOLVENCY,
  },
  {
    name: 'Order Queue',
    layout: '/admin',
    path: 'order-queue',
    icon: <MdListAlt className="h-6 w-6" />,
    component: <OrderQueue />,
    requiredPermission: PERMISSION_RESOURCES.ORDER_QUEUE,
  },
  {
    name: 'Rebalance Center',
    layout: '/admin',
    path: 'rebalance-center',
    icon: <MdSync className="h-6 w-6" />,
    component: <RebalanceCenter />,
    requiredPermission: PERMISSION_RESOURCES.ORDER_QUEUE,
  },
  {
    name: 'Fees',
    layout: '/admin',
    path: 'fees',
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <Fees />,
    requiredPermission: PERMISSION_RESOURCES.FEES,
  },
  {
    name: 'Notifications',
    layout: '/admin',
    path: 'public-notifications',
    icon: <MdCampaign className="h-6 w-6" />,
    component: <PublicNotifications />,
    requiredPermission: PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS,
  },
  {
    name: 'Pending Verification',
    layout: '/admin',
    path: 'kyc',
    icon: <VscUnverified className="h-6 w-6" />,
    component: <PendingVerifications />,
    requiredPermission: PERMISSION_RESOURCES.PENDING_VERIFICATION,
  },

  // {
  //   name: 'Cards',
  //   layout: '/admin',
  //   path: 'cards',
  //   icon: <IoCardSharp className="h-6 w-6" />,
  //   component: <Cards />,
  // },
  // {
  //   name: 'AML',
  //   layout: '/admin',
  //   path: 'aml',
  //   icon: <TbCurrencyDollarOff className="h-6 w-6" />,
  //   component: <AML />,
  // },
  // {
  //   name: 'Referrals',
  //   layout: '/admin',
  //   path: 'referrals',
  //   icon: <FaUserFriends className="h-6 w-6" />,
  //   component: <Refferals />,
  // },
  {
    name: 'Sign In',
    layout: '/auth',
    path: 'sign-in',
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
